import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import styles from './legendItem.module.scss';

const LegendItem = ({ label, color }) => {
  const [fontSize, setFontSize] = useState(14);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setFontSize(width > 1600 ? 16 : 14);
    };
    handleResize(); // Set initial font size based on current window width
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={styles['legend-item']}>
      <div className={styles.color} style={{ background: color }}></div>
      <span style={{fontSize}} className={styles.label}>{label}</span>
    </div>
  );
};

LegendItem.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default LegendItem;
